module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1255.c5af878b.png";